import { Mobile, Tablet, Desktop } from '../styles/Responsive';
import RegisterForm from '../components/forms/RegisterForm';
import ImgSlider from '../components/imgSlider/ImgSlider';
import './register.scss';

export default function Register(props) {

  return (
    <>
      <Mobile>
        <div className="m-loginContainer">
          <RegisterForm getToken={props.getToken} />
        </div>
      </Mobile>
      <Tablet>
        <div className="t-loginContainer">
          <div className="t-loginContent__grid">
            <RegisterForm getToken={props.getToken} />
            <ImgSlider />
          </div>
        </div>
      </Tablet>
      <Desktop>
        <div className="loginContainer">
          <ImgSlider />
          <RegisterForm getToken={props.getToken} />
        </div>
      </Desktop>
    </>
  );
}
